module.exports = __webpack_public_path__ + "static/media/nature-abstract-eco-concept-with-green-leaves-frame_1284-41031.ddce9f5a.jpg";